// extracted by mini-css-extract-plugin
export var alwaysSmall = "Tag-module--alwaysSmall--f5828";
export var tag = "Tag-module--tag--47711";
export var tagContainer = "Tag-module--tagContainer--8e721";